import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enPortal from './locales/portal/en';
import esPortal from './locales/portal/es';

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      lng: 'en',
      fallbackLng: 'en',
      supportedLngs: ['en', 'es'],
      interpolation: {
        escapeValue: false,
      },
      resources: {
        en: {
          portal: enPortal,
        },
        es: {
          portal: esPortal,
        },
      },
    });
}

export default i18n;
